export default __webpack_public_path__ + "static/media/edit-program.56500af2.svg";